import { type Theme } from "@mui/material"
import { SuggestionsPaperTheme } from "core/themes/src/definitions/components.types"

export const createSuggestionsPaperTheme = (theme: Theme): SuggestionsPaperTheme => ({
    styleOverrides: {
        root: {
            marginTop: -1,
            borderTopColor: theme.palette.primary.main,
            backgroundColor: theme.overwrites?.components?.textfield?.backgroundColor,
            "&::-webkit-scrollbar-track": {
                background: theme.overwrites?.components?.textfield?.backgroundColor,
            },

            // Firefox Unterstützung
            scrollbarColor: `#888 ${theme.overwrites?.components?.textfield?.backgroundColor}`,
        },
        groupHeader: {
            backgroundColor: theme.overwrites?.components?.textfield?.backgroundColor,
        },
    },
    variants: [],
})
